(function() {
  'use strict';

angular
  .module('factories.serviceLocator')
  .factory('serviceLocator', serviceLocator);

  serviceLocator.$inject = ['$location', '$window', 'trainerPreview'];

  function serviceLocator($location, $window, trainerPreview) {
    return {
      dashboardUrl: function () {
        return $window.mfConfig.viewAsTrainerUrl;
      },

      loginUrl: function () {
        return mfConfig.logoutUrl;
      },

      logout: function (params) {
        // params is currently only used in TraineeIpadWeb.

        // just close the window if previewing
        if (trainerPreview) {
          $window.close();
        } else {
          $window.location = mfConfig.logoutUrl;
        }
      }
    };
  }
})();